/* eslint-disable react/prop-types */
import { Table, Typography } from 'antd'

import summaryReportData from './utils/summaryReportData'

const { Text } = Typography

const EAReportTableSummary = ({ columns = [], dataSource = [] }) => {
  const hasSummary = columns.some((column) => column.summary === true)

  if (!hasSummary || !dataSource || dataSource.length === 0) {
    return null
  }

  const summaryData = summaryReportData(columns, dataSource)

  return (
    <Table.Summary>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={columns.length}>
          <Text strong>Total</Text>
        </Table.Summary.Cell>
      </Table.Summary.Row>

      <Table.Summary.Row>
        {summaryData.map((summary) => (
          <Table.Summary.Cell align={summary.align} key={summary.dataIndex}>
            {summary.total_str}
          </Table.Summary.Cell>
        ))}
      </Table.Summary.Row>
    </Table.Summary>
  )
}

export default EAReportTableSummary
